module.exports = __webpack_public_path__ + "static/media/anuradha.4fce8338.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/anuradha.png
// module id = 493
// module chunks = 0